import {
  addUploadBreadcrumb,
  captureImageUploadError,
  isHeic,
  newCorrelationId,
  reportEvent,
} from "../../service/monitoring";
import { useProductResolution } from "../../hooks/useProductResolution";
import Page404 from "./NotFound";
import { Grid, Box, Badge, IconButton } from "@mui/material";

import { BackLoadingSimple } from "../../composant/loading/backLoading";
import { useEffect, useState, useCallback, useRef } from "react";

import { useDispatch, useSelector } from "react-redux";
import { addImageAndSave } from "../../store/slice/gestionImageSlice";
import { useNavigate } from "react-router";
import ImageCard from "../../composant/imageGallery/ImageGallrey";
import PhotoImportCard from "../../composant/UploadFiles";
import { ImportButton } from "../../composant/UploadFiles";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import { useParams } from "react-router";

import "simple-keyboard/build/css/index.css";
import BarUploadProduct from "../../composant/bar/BarUploadProduct";
import { ConfirmClientTextPopup } from "../../composant/Popup/confirmClientText";
import {
  dbADDImageBg,
  dbADDImageSrcRm,
  editImageCount,
  dbEditImageText,
  dbDeleteImage,
  dbDeleteAllImages,
  dbUploadImage,
  dbLoadImages,
  saveDocumentTypeAtIndex,
} from "../../service/UploadServices";
import { useLocation } from "react-router-dom";
import heic2any from "heic2any";
import InputClientUploadFiles from "../../composant/clavie/InputClientUPloadfiles";

import DocumentSelector from "../../composant/option/DocumentSelector";
import BottomBar from "../../composant/navbar/ButtomBar";
import TitreTypography from "../../composant/Typography/TitreTypography";
import SousTitreTypography from "../../composant/Typography/SousTitreTypography";
import AddIcon from "@mui/icons-material/Add";
import axios from "axios";
import { api_base } from "../../env";
import PopupChangeBg from "../../composant/Popup/PopupChangeBg";
import ResizeAndCompressWithPica from "../../service/compresse";
import { useAlertContext } from "../../service/AlertServices";
export default function ImageUpload() {
  const [loading, setLoading] = useState(false);
  const [images, setImage] = useState([]);
  const { type } = useParams();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const event = params.get("event");
  const { product: dataProduit, status: productStatus } = useProductResolution(type);
  const [step, setstep] = useState(1);
  const fileInputRef = useRef(null);
  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const clientInfo = useSelector((state) => state.InfoCommand.clientCommand);
  const [background, setbackground] = useState();
  const [popupConfirm, setPopupConfirm] = useState(false);
  const [PopupChangeBgEtat, setPopupChangeBgEtat] = useState(false);
  const [indexImageChangeBg, SetIndexImageChangeBg] = useState();
  const { showAlert } = useAlertContext();
  console.log("images", images);

  async function AddImage(e) {
    setLoading(true);
    const acceptedFiles = Array.from(e.target.files || []);
    const startedAt = Date.now();
    console.log("acceptedFiles:", acceptedFiles);
    if (type === "photomaton") {
      const totalImages = images.length + acceptedFiles.length;
      if (totalImages > 3) {
        setLoading(false);
        showAlert(
          " Un maximum de 3 photos est autorisé pour le type Photomaton.",
          "error"
        );
        return;
      }
    }

    reportEvent("image_import.started", { product_type: type, file_count: acceptedFiles.length });
    const correlationId = newCorrelationId();
    const product = { id: dataProduit.id, type };
    const imageUploadPromises = acceptedFiles.map(async (file, index) => {
      let stage = "conversion";
      try {
        addUploadBreadcrumb("image_metadata_read", { file_index: index, name: file.name, size: file.size, mime_type: file.type });
        let convertedFile = file;

        // تحويل HEIC إلى JPEG أولاً
        if (isHeic(file)) {
          console.log("Converting HEIC to JPEG:", file.name);
          addUploadBreadcrumb("heic_conversion_started", { file_index: index });
          const blob = await heic2any({
            blob: file,
            toType: "image/jpeg",
            quality: 0.9,
          });
          convertedFile = new File(
            [blob],
            file.name.replace(/\.heic$/i, ".jpg"),
            {
              type: "image/jpeg",
            }
          );
          addUploadBreadcrumb("heic_conversion_success", { file_index: index, output_bytes: convertedFile.size });
        }

        console.log("File name:", convertedFile.name);
        console.log("File type:", convertedFile.type);
        console.log("File size (MB):", convertedFile.size / 1024 / 1024);

        // تقليل الحجم باستخدام pica
        stage = "compression";
        addUploadBreadcrumb("compression_started", { file_index: index });
        const compressedFile = await ResizeAndCompressWithPica(
          convertedFile,
          1920, // أقصى عرض
          0.8 // جودة الضغط
        );

        console.log(
          `✅ Compressed ${convertedFile.name}:`,
          (compressedFile.size / 1024 / 1024).toFixed(2),
          "MB"
        );

        addUploadBreadcrumb("compression_success", { file_index: index, output_bytes: compressedFile.size });
        reportEvent("image_compression.completed", { product_type: type, file_index: index, input_bytes: file.size, output_bytes: compressedFile.size, mime_type: file.type });
        return { name: file.name, file: compressedFile, idProduit: dataProduit.id, count: 1 };
      } catch (err) {
        addUploadBreadcrumb(`${stage}_failed`, { file_index: index });
        console.error("❌ Error during conversion or compression:", err);
        await captureImageUploadError({
          error: err,
          stage: `image_${stage}`,
          originalFile: file,
          product,
          correlationId,
          extra: { file_index: index, product_type: type },
        });
        throw err;
      }
    });

    try {
      const results = await Promise.allSettled(imageUploadPromises);
      const compressedFiles = results
        .filter((r) => r.status === "fulfilled")
        .map((r) => r.value);

      const failedFiles = results.filter((r) => r.status === "rejected");
      const newImages = compressedFiles;
      if (newImages.length > 0) {
        addUploadBreadcrumb("upload_prepared", { product_type: type, count: newImages.length });
        await dbUploadImage(type, newImages);
      }
      setImage((prev) => [...prev, ...newImages]);
      reportEvent("image_import.completed", {
        product_type: type, file_count: acceptedFiles.length,
        saved_count: newImages.length, failed_count: failedFiles.length,
        duration_ms: Date.now() - startedAt,
      });

      if (failedFiles.length > 0) {
        alert(
          `${failedFiles.length} image(s) failed to compress or upload. Check console for details.`
        );
      }
    } catch (error) {
      await captureImageUploadError({
        error,
        stage: "image_storage",
        product,
        correlationId,
        extra: { product_type: type, file_count: acceptedFiles.length },
      });
      console.error("Unexpected error:", error);
      alert("An unexpected error occurred. Please try again.");
    } finally {
      setLoading(false);
      setstep(1);
    }
  }

  function addpanier() {
    const hasText = images.some((img) => img.text);
    if (hasText || clientInfo.telephone) {
      addpanierData();
    } else {
      setPopupConfirm(true);
    }
  }
  const addpanierData = async () => {
    await dbDeleteAllImages(type);
    console.log("images after go to panier :", images);
    dispatch(addImageAndSave({ images: images, type: type }));
    navigate("/commande/inStore");
  };

  const deleteImage = async (index) => {
    const updatedImages = images.filter((item, i) => i !== index);
    setImage(updatedImages);
    await dbDeleteImage(type, index);
    if (updatedImages.length === 0) {
      setstep(0);
    }
  };

  const handleCountChange = async (index, delta) => {
    console.log("index", index, "| delta", delta);
    setImage((currentImages) =>
      currentImages.map((img, imgIndex) => {
        if (imgIndex === index) {
          //  const newCount = Math.max((img.count || 0) + delta, 0);

          return { ...img, count: delta };
        }
        return img;
      })
    );

    //const newCount = Math.max((currentImages[index]?.count || 0) + delta, 0);
    await editImageCount(type, index, delta);
  };
  /*
  const handleColorChange = async (index, color) => {
    setImage((currentImages) =>
      currentImages.map((img, imgIndex) => {
        if (imgIndex === index) {
          // Ensure count doesn't go below 0
          return { ...img, color: color };
        }
        return img;
      })
    );
    await saveColorAtIndex(type, index, color);
  };
*/
  const handleDocumentTypeChange = async (index, documentType) => {
    setImage((currentImages) =>
      currentImages.map((img, imgIndex) => {
        if (imgIndex === index) {
          return { ...img, documentType };
        }
        return img;
      })
    );
    await saveDocumentTypeAtIndex(type, index, documentType);
  };

  const memoizedDbLoadImages = useCallback(dbLoadImages, []);

  function RemoveBgAndOpenPopup(index) {
    SetIndexImageChangeBg(index);
    if (images[index].srcRm) {
      setPopupChangeBgEtat(true);
      return;
    }
    setLoading(true);
    const formData = new FormData();
    formData.append("image", images[index].file);
    axios
      .post(`${api_base}images/RemoveBackground`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        const updatedImages = [...images];
        updatedImages[index].srcRm = response.data.image;
        setImage(updatedImages);
        dbADDImageSrcRm(type, index, response.data.image);
        setPopupChangeBgEtat(true);
      })
      .catch((error) => {
        console.error("Error changing background:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  function handleChangeBg(bg) {
    const updatedImages = [...images];
    updatedImages[indexImageChangeBg].Bg = bg;
    setImage(updatedImages);
    dbADDImageBg(type, indexImageChangeBg, bg);
    SetIndexImageChangeBg(null);
    setPopupChangeBgEtat(false);
  }

  useEffect(() => {
    const loadImageInState = async () => {
      const data = await memoizedDbLoadImages(type);
      setImage(data);
    };

    loadImageInState();
  }, [type, memoizedDbLoadImages]);
  useEffect(() => {
    axios
      .get(`${api_base}background/GetDefaultBackgrounds`)
      .then((res) => setbackground(res.data));
  }, []);

  if (productStatus === "loading") {
    return <BackLoadingSimple open />;
  }
  if (productStatus === "not_found") {
    return <Page404 />;
  }

  return (
    <>
      <div style={{ background: "#f7f7f7", minHeight: "100vh" }}>
        <Box>
          <Grid
            container
            spacing={4}
            sx={{
              marginBottom: {
                xs: "15%",
                md: "5%",
              },
            }}
          >
            <Grid item xs={12}>
              <BarUploadProduct
                sousTitre="Tirage photo"
                titre={`Tirage ${type}`}
                beforeOnClik={() => {
                  navigate(`/InformationProduct/${type}`);
                }}
              />
            </Grid>
            {step === 0 && (
              <Grid item xs={12} sx={{ mt: images.length === 0 ? 0 : 10 }}>
                <Grid container spacing={4} textAlign="center">
                  <Grid
                    item
                    xs={12}
                    //  md={images.length === 0 ? 6 : 12}
                    textAlign="center"
                    marginTop="40px"
                  >
                    <PhotoImportCard
                      AddImage={AddImage}
                      affichage={true}
                      event={event}
                    />
                  </Grid>
                  {images.length !== 0 && (
                    <Grid item xs={12} marginTop="-40px">
                      <Grid container spacing={2} padding={4}>
                        <Grid item xs={12}>
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "space-between",
                              width: "100%",
                            }}
                          >
                            <TitreTypography>Photo récente</TitreTypography>
                            <div onClick={() => setstep(1)}>
                              <SousTitreTypography onClick>
                                Voir tout
                              </SousTitreTypography>
                            </div>
                          </Box>
                        </Grid>
                        {images?.map((img, index) => (
                          <Grid
                            item
                            xs={4}
                            md={2}
                            lg={1}
                            key={index}
                            sx={{ width: "100%" }}
                            textAlign="center"
                          >
                            <img
                              src={URL.createObjectURL(img.file)}
                              alt={type}
                            />
                          </Grid>
                        ))}
                      </Grid>
                    </Grid>
                  )}
                </Grid>
              </Grid>
            )}
            {step === 1 && (
              <Grid
                item
                xs={12}
                sx={{
                  width: "100%",
                  marginBottom: { xs: "20%", md: "10%" },
                }}
              >
                <Grid
                  container
                  spacing={4}
                  textAlign="center"
                  marginBottom="100px"
                >
                  {images?.map((img, index) => (
                    <Grid
                      item
                      xs={12}
                      md={6}
                      lg={3}
                      key={index}
                      sx={{ width: "100%" }}
                      textAlign="center"
                    >
                      <Box
                        sx={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <Box sx={{ width: "90%" }}>
                          <ImageCard
                            src={URL.createObjectURL(img.file)}
                            onDelete={() => deleteImage(index)}
                            type={type}
                            badgeContent={img.count}
                            index={index}
                            handleCountChange={handleCountChange}
                            Rm_bg={dataProduit?.removeBg}
                            changeBackground={RemoveBgAndOpenPopup}
                            srcRm={img.srcRm ? img.srcRm : false}
                            urlBg={img.Bg ? img.Bg.Url : false}
                            displayCount={type !== "photomaton"}
                          />
                        </Box>
                      </Box>

                      {dataProduit?.text && (
                        <InputClientUploadFiles
                          text={img.text}
                          index={index}
                          dbEditImageText={(index, newtext) =>
                            dbEditImageText(type, index, newtext)
                          }
                          setImage={setImage}
                        />
                      )}
                      {dataProduit.type === "identite" && (
                        <DocumentSelector
                          index={index}
                          documentType={img.documentType || ""}
                          setDocumentType={(newType) =>
                            handleDocumentTypeChange(index, newType)
                          }
                        />
                      )}
                      {/**  <Box
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      width="100%"
                      mb={1}
                    >

                      <Autocomplete
                        freeSolo
                        fullWidth
                        options={suggestions}
                        getOptionLabel={(option) => option.text || ""}
                        loading={loadingSuggestions}
                        inputValue={img.text || ""}
                        onInputChange={(event, newInputValue, reason) => {
                          handleTextChange(index, newInputValue);
                          if (reason === "input") {
                            fetchSuggestions(newInputValue);
                          }
                        }}
                        onChange={(event, newValue) => {
                          if (newValue) {
                            const valueToAdd =
                              typeof newValue === "string"
                                ? newValue
                                : newValue.text || "";
                            handleTextChange(index, valueToAdd);
                          }
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="outlined"
                            placeholder="Votre Texte"
                            sx={{
                              width: "90%",
                              background: "white",
                              marginTop: "10px",
                              "& .MuiOutlinedInput-root": {
                                "& fieldset": {
                                  borderColor: "grey",
                                  borderRadius: "15px",
                                },
                                "&:hover fieldset": {
                                  borderColor: "black",
                                },
                                "&.Mui-focused fieldset": {
                                  borderColor: "black",
                                },
                              },
                            }}
                            InputProps={{
                              ...params.InputProps,
                              endAdornment: (
                                <>
                                  {loadingSuggestions && (
                                    <CircularProgress
                                      color="inherit"
                                      size={20}
                                    />
                                  )}
                                  {params.InputProps.endAdornment}
                                  <InputAdornment position="end">
                                    <IconButton
                                      onClick={() => {
                                        setIndexInputHashTag(index);
                                        setopenHashTags(true);
                                      }}
                                    >
                                      <TagIcon />
                                    </IconButton>
                                    <IconButton
                                      onClick={() => handleOpenKeyboard(index)}
                                    >
                                      <AddReactionIcon />
                                    </IconButton>
                                  </InputAdornment>
                                </>
                              ),
                            }}
                          />
                        )}
                      />
                    </Box>

                    {keyboardOpen && activeIndex === index && (
                      <CustomKeyboard
                        inputValue={inputValue}
                        onChange={onChange}
                        onKeyPress={handleKeyPress}
                        layoutName={currentLayout}
                        closeKeyboard={handleCloseKeyboard}
                        showEmojiOnly={true}
                      />
                    )} */}
                    </Grid>
                  ))}
                </Grid>
                {images.length !== 0 && (
                  <Box
                    sx={{
                      position: "fixed",
                      bottom: "10%",
                      left: "50%",
                      transform: "translateX(-50%)",
                      width: "90%",
                      display: "flex",
                      justifyContent: "center",
                      zIndex: 3,
                    }}
                  >
                    <ImportButton
                      variant="contained"
                      height="70px"
                      fullWidth
                      disabled={
                        (type === "photomaton" && images.length < 3) ||
                        images.length === 0
                      }
                      /*
  startIcon={
    <Badge
      badgeContent={images.length}
      sx={{
        "& .MuiBadge-badge": {
          color: "#e63e57",
          backgroundColor: "white",
        },
      }}
    >
      <AddShoppingCartIcon />
    </Badge>
  }
  */
                      onClick={addpanier}
                    >
                      Ajouter au panier
                    </ImportButton>
                  </Box>
                )}
                <Box
                  sx={{
                    position: "fixed",
                    bottom: "20%",
                    right: "5%",
                    display: "flex",
                    justifyContent: "center",
                    zIndex: 3,
                  }}
                >
                  <IconButton
                    onClick={handleButtonClick}
                    sx={{
                      backgroundColor: "#EF8192",
                      color: "white",
                      "&:hover": {
                        backgroundColor: "white",
                        color: "#EF8192",
                      },
                      width: 56,
                      height: 56,
                    }}
                  >
                    <AddIcon />
                  </IconButton>
                </Box>
              </Grid>
            )}
          </Grid>

          {images.length !== 0 && (
            <>
              <Box sx={{ display: { xs: "none", md: "flex" } }}>
                <footer
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    borderTop: "1px solid #ccc",
                    position: "fixed",
                    left: "0",
                    bottom: "0",
                    width: "100%",
                    background: "white",
                    paddingLeft: "2%",
                    paddingRight: "2%",
                  }}
                ></footer>
              </Box>
              <Box sx={{ display: { xs: "flex", md: "none" } }}>
                <footer
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    position: "fixed",
                    left: "0",
                    bottom: "0",
                    width: "100%",
                    background: "white",
                    paddingLeft: "2%",
                    paddingRight: "2%",
                  }}
                >
                  <ImportButton
                    variant="contained"
                    fullWidth
                    height="70px"
                    startIcon={
                      <Badge
                        badgeContent={images.length}
                        fontSize="large"
                        sx={{
                          "& .MuiBadge-badge": {
                            color: "#e63e57",
                            backgroundColor: "white",
                          },
                        }}
                      >
                        <AddShoppingCartIcon />
                      </Badge>
                    }
                    onClick={addpanier}
                  >
                    imprimer
                  </ImportButton>
                </footer>
              </Box>
            </>
          )}

          <BottomBar />
          <ConfirmClientTextPopup
            open={popupConfirm}
            onClose={() => {
              setPopupConfirm(false);
            }}
            confirm={addpanierData}
          />
          <PopupChangeBg
            open={PopupChangeBgEtat}
            onClose={() => setPopupChangeBgEtat(false)}
            imageWithoutBg={images[indexImageChangeBg]?.srcRm}
            bgList={background}
            onSave={handleChangeBg}
          />
          <BackLoadingSimple open={loading} />
          <input
            type="file"
            ref={fileInputRef}
            style={{ display: "none" }}
            accept="image/*"
            multiple
            onChange={AddImage}
          />
        </Box>
      </div>
    </>
  );
}
